import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import Loader from 'components/Loader';
import NotificationServices from 'services/HeaderNotifications';
import {HtmlParse} from 'utils';
import importantIcon from 'images/icons/important.svg';
import Item from './Item';
import PubSub from 'services/PubSub';
import Tooltip from 'components/Tooltip';
import {chatOrdersFlag} from 'config';
import style from './style.scss';

let actions = [];

if (typeof window !== 'undefined') {
    window.openTooltip = (open) => {
        PubSub.dispatch('open_tooltip', open);
    }
}

const Notifications = () => {
    const [showPoint, setShowPoint] = useState(false);
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState(false);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        actions.push(PubSub.register('toggle_notify', () => setOpen(false)));
        actions.push(PubSub.register('open_tooltip', openFakeTooltip));

        _getNotifications();

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = []
        }
    }, [])

    const openFakeTooltip = (payload) => {
        setShowTooltip(!payload.value);
        setShowTooltip(payload.value)
    }

    const _getNotifications = () => {
        NotificationServices.getNotifications().then(data => {
            if(data && data.notifications && data.notifications.length) {
                const newNotification = data.notifications.filter(item => !item.read);
                setShowPoint(!!newNotification.length);
                setData(data.notifications);
            }
        })
    }

    const openDropdown = () => {
        setOpen(!open);

        PubSub.dispatch('toggle_minicart', { state: false });
        PubSub.dispatch('toggle_menu', { state: false });
        NotificationServices.readNotifications().then(result => {
            if(result && result.status === 200) {
                setShowPoint(false);
            }
        })
        _getNotifications();
    }

    const openOptions = () => {
        setOptions(!options);
    }

    const deleteNotifications = () => {
        setLoading(true);
        setOptions(false);

        NotificationServices.deleteNotifications().then(result => {
            if(result && result.status === 200) {
                setData(null);
            }

            setLoading(false);
        })
    }

    const getButton = () => {
        return(
            <button className="header-notifications-btn" onClick={() => openDropdown()}>
                {showPoint && <i className="header-notificacions-point"></i>}
                <i className='jumbo-icon-new-bell'></i>
            </button>
        )
    }
        
    return (
        <div className='header-notifications'>
            {!chatOrdersFlag && getButton()}
            {chatOrdersFlag && <Tooltip message={HtmlParse('Tienes <strong>2 mensajes</strong> de tu shopper')} button='Entendido' once={true} timer={1000} defaultView={{show:showTooltip}} type='message-chat' >
                {getButton()}
            </Tooltip>}
            <span className="header-notifications-title" onClick={() => openDropdown()}>Notificaciones</span>

            <div className={'header-notification-arrow-up' + (open ? ' show' : '')}></div>
            <div className={'header-notifications-list-wrap' + (open ? ' show' : '')}  onMouseLeave={() => { setOpen(false) }}>
                {loading && <div className='header-notifications-loader'><Loader /></div>}
                <div className='header-notifications-list-title-wrap'>
                    <div>
                        <span className='header-notifications-list-title'>Notificaciones</span>
                        <span className='header-notifications-list-quantity'>{ data ? data.length : ''}</span>
                    </div>

                    <button onClick={() => openOptions()}><i className={"jumbo-icon-new-menu " + (options ? ' change-color ' : '')}></i></button>
                </div>

                <div className={'header-notification-options-arrow-up' + (options ? ' show' : '')}></div>
                <div className={'header-notifications-options-wrap' + (options ? ' show' : '')} onMouseLeave={() => { setOptions(false) }}>
                    {data && <button className='notifications-option-btn-text' onClick={deleteNotifications}>Eliminar todas</button>}
                    <Link to={'/mis-datos'} onClick={() => { setOpen(false) }}><button className='notifications-option-btn-text'>Gestionar notificaciones</button></Link>
                </div>
                {(data && data.length > 0) &&  <>
                    <ul className='notifications-list'>
                        {data && data.map((item, i) => {
                            const isOrder = item.urlTarget === '_order' || item.urlTarget === '_collection';
                            const link = isOrder ? ('/mis-compras/' + item.url) : item.url;

                            return (
                                <Item item={item} isOrder={isOrder} link={link} setOpen={setOpen} key={i}/>
                            )})}
                    </ul>
                </>}

                {!data && <>
                    <div className="no-have-notifications-wrap">
                        <i className='no-have-notifications-icon'>{HtmlParse(importantIcon)}</i>
                        <span>Aún no tienes notificaciones</span>
                        <span>Vuelve más tarde</span>
                    </div>
                </>}
            </div> 
        
        </div>
    )
}

export default Notifications;
